/**
 * @Page APICH
 * @Description [APICH]수신자료관리 - 협력사 정보 연계 - 부품출하정보
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import GridRibbon from "@/components/organisms/GridRibbon";
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
 import CommonUtil from '@/utils/CommonUtil';  
 import Popup from '@/pages/Popup/Popup';    
 
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const gbn = [{ "comCode" : "****",  "text": "공통" }];  //조회조건 구분 
 const Utils = new CommonUtil();
 
 function APICH() {
     const token = Common.getToken();
     const userId = Common.getToken("id");
     const userName = Common.getToken("name");
     const tVnt1 = Common.getToken("vand");
     const tComp = Common.getToken("comp");
     const grdAPICHList = useRef();   //Grid1
     const grdAPICHDetail = useRef();  //Grid2
     const master = Common.getToken("masterKey");
     let [loading, setLoading] = useState(false);
     
     //Data
     const [idata, setData] = useState({
        //조회조건
        kVnt1 : tVnt1,      //T1업체
        kComp: tComp,       //회사구분
        kNpdt:  Common.getToday(), // 발행일자 :: Default 값 셋팅       
        kPlnt: "",          //공장
        kDlno : "",         //납품서번호
        kGubn: "1",         // 조회구분(OEM) :: Default 값 셋팅       
        kGubn2: "",        // 조회구분(CKD) :: Default 값 셋팅

        ZASNNO:"",
        //코드 데이터
        vnt1List : [],  //T1업체
        plntList : [],  //공장
        kMaster : master, //마스터 계정 여부
     }); 


      //납품내역 복구 Popup
    const [redeilOpen, setRedeilOpen] = React.useState(false);
 
      
     const [message, setMessage] = React.useState( {
         openAlert : false,      
         severity : "success",   
         msg : ""                
     });
     const { openAlert, severity, msg } = message;
 
 
     //Dialog
     const [dlgMessage, setDlgMessage] = React.useState( {
         openDlg : false,    
         dlgTrans : "",      
         dlgMsg : ""         
     });

     const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
 
 
     //Grid Search, Insert, Update, Delete Api
     let [searchApi, setSearchApi] = useState(false); 
     let [searchApi2, setSearchApi2] = useState(false); 
     const [panded, setPanded] = React.useState(true);
     //  const [style, setStyle] = useState({ height :"calc(100vh - 60px - 50px - 55px  - 80px)",padding: "0px 10px 35px 10px" });
     const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"});

     let [clearGrid, setClearGrid] = useState(false);  

     const onClearApi = useCallback(async (e) => {
         setSearchApi(false);
         setSearchApi2(false);
     }, []);



      /**
     * 수정 
     * @param {*} e 
     * @returns 
     */
    const onUpdate = async (e) => {
        //삭제내역 복구 Popup Open
        setRedeilOpen(true);
    }
 
     /**
      * 공통코드 조회
      */
      const onSearchCommon = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                        commonData[name] = data.data
                        setData({...commonData});
                    }
                })
        }
        fetchData(para, name);
    }
 
     /**
      *MOUNT 
      */
     useEffect( () => {
        //공통코드 조회 (T1업체)
        onSearchCommon(`{"pgmid":"VNT1"}`, "vnt1List");

        //공통코드 조회 (공장)
        onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"VMI"}`, "plntList");

     }, []);
 
     /**
      * Control 변경 Event
      * @param {*} e 
      */
     const onChange = async (e) => {
         const { name, value } = e.target;

         let newSearchs = idata;
         newSearchs[name] = value
         setData({ ...newSearchs });

         
        //T1업체, 회사구분 변경시 
        if (name === "kVnt1" || name === "kComp" || name === "kGubn")  {
            newSearchs["plntList"] = [];
            newSearchs["kPlnt"] = "";
            newSearchs[name] = value;
            setData({ ...newSearchs });
            onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"VMI"}`, "plntList");   
            //공통코드 조회 (공장)
            if(idata.kGubn == 1){
                onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"VMI"}`, "plntList1");   
            }
            else{
                onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"CKD"}`, "plntList2");   
            }
        }

        
        if (name === "kGubn") onSearch();

     }
 
     /**
      * Grid Event 
      * @param {*} e 
      */

      //grdAPICHList Grid Row Click
    const grdAPICHList_onRowClicked = async (e) => {
        let data = e.data;
        console.log("data")
        console.log(data)

        //Detail Grid 조회
        onSearch2(data.ZASNNO, data.kNpdt);
    }


     const onCellValueChanged = async (e) => {
     }
 
     const onRowClicked = async (e) => {
     }

     /**
      * 검색조건
      */
      const optionsX = {
        0: [
            //T1업체
            {
                "formatter": "select", "name": "kVnt1", "labelName": "T1업체", "type": "text", "defaultValue": idata.kVnt1,  
                "codeMode": true,
                "selectAll": "",
                "codes": null,
                "comms": idata.vnt1List,
                "align": "left", 
            }, 
            //회사구분
            {
                "formatter": "select", "name": "kComp", "labelName": "회사구분", "type": "text", "defaultValue": idata.kComp,  
                "codeMode": true,
                "selectAll": "",
                "codes": CODES["comp"],
                "comms": null,
                "align": "left", 
            }, 
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" }
            
        ],
        1: [
            //발행일자
            {
                "formatter": "input", "name": "kNpdt", "labelName": "계획일자", "type": "date", "desc": "", "readOnly" : false, "clearButton": true,
                "defaultValue": idata.kNpdt,  
                "align": "left", 
                "labelType": "none" 
            }, 
             //납품서번호
            {
                "formatter": "input", "name": "kDlno", "labelName": "납품서번호", "type": "text", "desc": "", "readOnly" : false, "clearButton": true,
                "defaultValue": idata.kDlno,  
                "align": "left",
                "labelType": "none", 
            }, 
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" },
            {"formatter": "blank", "align": "left" }
        ]
     }
 

     /**
      * 조회 
      * @param {*} e 
      * @returns 
      */
    const onSearch = async (e) => {

        //발행일자, 납품서 번호 입력 CHECK
        if(idata.kNpdt == "" && idata.kDlno == ""){
            setMessage({ openAlert : true, 
                severity : "info",
                msg : "계획일자 혹은 납품서 번호를 입력하십시오 !"});
            document.getElementById("kNpdt").focus();                         
            return ;
        }

        if(idata.kNpdt == ""){
            setMessage({ openAlert : true, 
                severity : "info",
                msg : "계획일자를 선택해주세요"});
            document.getElementById("kNpdt").focus();                         
            return ;
        }

        if(idata.kDlno == ""){
            setMessage({ openAlert : true, 
                severity : "info",
                msg : "납품서번호를 입력해주세요"});
            document.getElementById("kDlno").focus();                         
            return ;
        }
        
        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1"+userId,idata.kVnt1,1);
        let trimed_dlno = idata.kDlno.trim();

        let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", 
                     "kNpdt":"${idata.kNpdt}","kDlno":"${trimed_dlno}"}`;

        let param = encodeURI(para);
        //PartChul/search >>>>>>>> 부품출하정보

        if(idata.kNpdt != "" && idata.kDlno == ""){
            const query = SERVER_URL + "/AutoReceiver/PartChul/search?query=" + param;  

            setSearchApi(query); // Search API            
            setClearGrid(true);
            
        }
        else if((idata.kNpdt == "" && idata.kDlno != "") || (idata.kNpdt != "" && idata.kDlno != "")){
            const query = SERVER_URL + "/AutoReceiver/PartChul/search?query=" + param;
            // const query2 = SERVER_URL + "/AutoReceiver/PartChul/search2?query=" + param;
            
            setSearchApi(query); // Search API
            // setSearchApi2(query2); // Search2 API
        }
    }

     const onSearch2 = async (dlno, kNpdt) => {   
        
         //ZASNNO  납품서 번호
        let para = `{"kDlno":"${dlno}"}`;
        let param = encodeURI(para);
        
        const query2 = SERVER_URL + "/AutoReceiver/PartChul/search2?query=" + param;
        setSearchApi2(query2); // Search2 API

        //납품서 번호 엑셀용
        let newSearchs = idata;
        newSearchs["ZASNNO"] = dlno
        setData({ ...newSearchs });
    }


     //Transaction AlertDialogResult
     const AlertDialogResult = async (e) => {
 
         //AlertDialog 초기화
         setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});
        
         //DialogResult
         if (e.result == "N") return;
 
         //Transaction 구분
         switch (e.Trans) 
         {
             //등록
             case "I" :
                 break;
             //수정
             case "U" :
                 break;
             //삭제
             case "D" :
                 break;
         }
     } 

      /**
     * 엑셀
     * @param {*} e 
     */
     const onExcel = async (e) => {
            const page = "PART_CHUL"
            //,"kDocd":"${idata.kDocd}","docdNm":"${idata.kDocd===""?"전체":idata.kDocd}"
            let para = `{"kDocument":"부품출하정보",
                        "kGubn":"${page}","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}",
                        "kDlno":"${idata.ZASNNO}",
                        "vnt1Nm":"${idata.kVnt1Nm}","compNm":"${idata.kCompNm}","kTotcnt": "${idata.kTotcnt}"}`;
            
            let param = encodeURIComponent(para);
            const query = SERVER_URL + "/AutoReceiver/excel?query=" + param;
            //엑셀파일 조회 시 반응
            setLoading(true);
            await fetch(query, {headers: {Authorization: token } })
                .then((resp) =>{
                    return resp.blob();
                }).then((blob)=>{
                    const href = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', '부품출하정보.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch((err) => {
                    return Promise.reject({ Error: 'error', err });
                })
            setLoading(false);

            // 엑셀파일 생성 메세지
            setMessage({ openAlert : true, 
                        severity : "success",
                        msg : "엑셀파일이 생성되었습니다."});
            
        }
     


        /**
         *Grid Column 정의 
        */
    //납품서 발행 Grid Column
    const columnDefs1 = [
        { headerName: "납품서번호", field: "ZASNNO", sortable: true, filter: true, flex: 1, maxWidth : 120,  minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "ASN유형", field: "ZASNTY", sortable: true, filter: true, flex: 1, maxWidth : 80,  minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "송장번호", field: "ZDIVNO", sortable: true, filter: true, flex: 1, maxWidth : 120,  minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "출발날짜", field: "ZDEPDAT", sortable: true, filter: true, flex: 1, maxWidth : 80,  minWidth: 80,cellClass: ["nocheckbox", "alignC"], valueFormatter: Utils.dateFormatter,singleClickEdit: false, hide: false },
        { headerName: "출발시간", field: "ZDEPTIM", sortable: true, filter: true, flex: 1, maxWidth : 80,  minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false , valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "예상도착시간(날짜)", "ZEARDAT": "isdt", sortable: true, filter: true, flex: 1, maxWidth : 90,  minWidth: 80,cellClass: ["nocheckbox", "alignC"], valueFormatter: Utils.dateFormatter,singleClickEdit: false, hide: false },
        { headerName: "예상도착시간(시간)", field: "ZEARTIM", sortable: true, filter: true, flex: 1, maxWidth : 90,  minWidth: 80, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false },
        { headerName: "차번호", field: "ZCARNO", sortable: true, filter: true, flex: 1, maxWidth : 90,  minWidth: 50, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "운전자명", field: "ZDLRNAME", sortable: true, filter: true, flex: 1, maxWidth : 130,  minWidth: 130, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "운전자전화번호", field: "ZDLRMOBL", sortable: true, filter: true, flex: 1, maxWidth : 90,   editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "배송업체", field: "ZDLTLOC", sortable: true, filter: true, flex: 1, maxWidth : 90,  cellClass: ["nocheckbox", "alignC"], cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
        { headerName: "태그번호", field: "ZCTAG_CO", sortable: true, filter: true, flex: 1, maxWidth : 90,  cellClass: ["nocheckbox", "alignC"], cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},

    ];


    //납품서 상세현황 Grid Column
    const columnDefs2 = [            
            { headerName: "납품서번호", field: "ZASNNO", sortable: true, filter: true, flex: 1, maxWidth : 150,  minWidth: 150,hide: true },
            { headerName: "SP ASN 아이템", field: "ZASNSEQ", sortable: true, filter: true, flex: 1, maxWidth : 150,  minWidth: 150, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
            { headerName: "공장", field: "WERKS", sortable: true, filter: true, flex: 1, maxWidth : 90,  minWidth: 70, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
            { headerName: "공장명", field: "ZPNTNM",sortable: true, filter: true, flex: 1, maxWidth : 200,  minWidth: 150, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: false, hide: false},
            { headerName: "품번", field: "MATNR", sortable: true, filter: true, flex: 1, maxWidth : 150,  minWidth: 150, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, valueGetter: Utils.partnoGetter, hide: false },
            { headerName: "배송수량", field: "ZDLMENGE", sortable: true, filter: true, flex: 1, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, valueFormatter: Utils.numberFormatter, hide: false },
            { headerName: "GR수량", field: "ZGRMENGE", sortable: true, filter: true, flex: 1, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, valueFormatter: Utils.numberFormatter, hide: false },
            { headerName: "삭제플래그", field: "LOEKZ", sortable: true, filter: true, flex: 1, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: false, hide: false},
    ];

        
    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                // height :"calc(100vh - 60px - 50px - 30px)",
                // padding: "0px 10px 35px 10px" 
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
              });
        }else{
            setStyle({
                // height :"calc(100vh - 60px - 50px - 55px  - 80px)",
                // padding: "0px 10px 35px 10px" 
                height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"

              });
        }
    }

     return(
         <>
             {/* Dialog FRAME */}
             <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult}/>

              {/* 삭제내역 복구  */}
            <div id ="11">
            <Popup type="Redeli" open={redeilOpen} onClose={()=> {setRedeilOpen(false)}}/>
            </div>
 
             {/* Alert FRAME */}
             <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
 
                     
             {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
             <Ribbon
                // onInfoMsg={""}
                onInfoManual={false}                        // onInfoManual : 매뉴얼 표출 버튼 무조건 사용 // false : 사용안함 (popup 의경우 false 셋팅)
                 onSearch={onSearch} onSearchName={null}     //조회
                 onExcel={onExcel} onExcelName ={null}   //Excel
                >
                 {"수신자료관리 > 협력사정보연계 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>부품출하정보</b>
             </Ribbon>
 
 
             {/* ContentXearch Frame : 검색조건 */}
             <ContentXearch
                 optionsX={optionsX}
                 onChange={onChange}
                 onClick={onClick} />
 
 
             {/* Content FRAME (Data / Grid Frame) START -------------- */}
             <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:55px */}
             <div className="grid_type02" style={{margin : "0px"}}>{/* 상단 FRAME */}
                    <div className="grid_wrap02" style={{width:"46%" }}> {/* 상단 wrap 좌측 FRAME */}
                        <div className="grid_area"> {/* Grid area */}
                            <GridRibbon 
                                title={"납품서 발행현황"}>
                            </GridRibbon>
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>

                                {/* Grid1 */}
                                <Grid
                                    ref={grdAPICHList}
                                    gridId={"APICH"}                   //  (필수) Grid Id 정의
                                    columnDefs={columnDefs1}            //  (필수) 컬럼 정의 
                                    pagination={false}                  //  쪽수 매기기 여부
                                    paginationCsv={false}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                    paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                    rowMultiSelectWithClick={false}      //  멀티 클릭 가능 여부
                                    suppressRowClickSelection={false}    //  클릭으로 선택 하는것을 방지
                                    rowSelection={"single"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                    enableRangeSelection={false}        //  
                                    enableCellTextSelection={true}      // cell selection drag mode
                                    isFirst={false}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                    displayNo = {false}
                                    useMessage = {true}                 // 메세지 창 설정
                                    onClearApi={onClearApi}            // 초기화
                                    searchApi={searchApi}              // 조회
                                    onRowClickEvent={grdAPICHList_onRowClicked}
                                />
                            </div>
                        </div>
                    </div>
                

                    <div className="grid_wrap03" style={{width:"54%" }}> {/* 하단 wrap 우측 FRAME */}
                        <div className="grid_area"> {/* Grid area */}
                            <GridRibbon 
                                title={"납품서 상세현황"}>
                            </GridRibbon>
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>

                                {/* Grid2 */}
                                <Grid
                                    ref={grdAPICHDetail}
                                    gridId={"APICH2"}                   //  (필수) Grid Id 정의
                                    columnDefs={columnDefs2}            //  (필수) 컬럼 정의 
                                    pagination={false}                  //  쪽수 매기기 여부
                                    paginationCsv={false}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                    paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                    rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                    suppressRowClickSelection={false}   //  클릭으로 선택 하는것을 방지
                                    rowSelection={"multiple"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                    enableRangeSelection={false}        //  
                                    enableCellTextSelection={true}      // cell selection drag mode
                                    isFirst={false}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                    displayNo = {false}                 // No 컴럼 Display
                                    searchApi={searchApi2}              // 조회
                                    onClearApi={onClearApi}            // 초기화
                                    clearGrid={clearGrid}
                                    onClearGridFlag={setClearGrid}
                                    useMessage = {false}                 // 메시지창 설정
                                />
                            </div>
                        </div>
                    </div>
                </div>
             </Content>
         </>
     )
 }
 export default APICH;